import script from "./BankData.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankData.vue?vue&type=script&setup=true&lang=ts"

import "./BankData.vue?vue&type=style&index=0&id=26fccc06&lang=scss"

const __exports__ = script;

export default __exports__